"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileGuidedFlow = void 0;
var react_1 = __importStar(require("react"));
var styles = __importStar(require("./MobileGuidedFlow.css"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var inversify_react_1 = require("inversify-react");
var scroll_into_view_if_needed_1 = __importDefault(require("scroll-into-view-if-needed"));
var Utils_1 = require("./Utils");
var Utils_2 = require("./Utils");
var mobx_react_1 = require("mobx-react");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var lodash_1 = require("lodash");
exports.MobileGuidedFlow = (0, mobx_react_1.observer)(function (_a) {
    var onCloseNavDrawer = _a.onCloseNavDrawer;
    var _b = __read((0, react_1.useState)("start"), 2), state = _b[0], setState = _b[1];
    var guidedFlowStore = (0, inversify_react_1.useInjection)("guidedFlowStore");
    var acceptedInCurrentSession = (0, inversify_react_1.useInjection)("acceptedInCurrentSession");
    var acceptFlowGlobalStore = (0, inversify_react_1.useInjection)("acceptFlowGlobalStore");
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var isMobile = (0, inversify_react_1.useInjection)("isMobile");
    var _c = __read((0, react_1.useState)(isMobile()), 2), isMobileDevice = _c[0], setIsMobileDevice = _c[1];
    var resizeObserver = (0, react_1.useRef)(null);
    var isCurrentSlotFilled = acceptFlowGlobalStore.isSlotFilledInAllStores(acceptFlowGlobalStore.currentSlot);
    var isAnySlotFilled = acceptFlowGlobalStore.currentSlot !== null &&
        acceptFlowGlobalStore.isSlotFilledInAnyStore(acceptFlowGlobalStore.currentSlot);
    (0, react_1.useEffect)(function () {
        if (guidedFlowStore.currentStepState || isAnySlotFilled) {
            if (isCurrentSlotFilled) {
                if (state === "filling") {
                    (0, scroll_into_view_if_needed_1.default)(document.querySelector((0, Utils_2.getElementSelector)("component", "accept-form-heading")), (0, Utils_1.getScrollOptionsByStepType)("accept-flow"));
                }
                if (acceptedInCurrentSession()) {
                    setState("accepted");
                    onCloseNavDrawer === null || onCloseNavDrawer === void 0 ? void 0 : onCloseNavDrawer();
                }
                else {
                    setState("complete");
                    onCloseNavDrawer === null || onCloseNavDrawer === void 0 ? void 0 : onCloseNavDrawer();
                }
            }
            else {
                setState("filling");
            }
        }
        else {
            setState("start");
        }
        if ("ResizeObserver" in window) {
            (0, lodash_1.defer)(function () {
                var agreementElement = document.querySelector("section.Agreement");
                if (agreementElement && !resizeObserver.current) {
                    resizeObserver.current = new ResizeObserver(function () {
                        setIsMobileDevice(isMobile());
                    });
                    resizeObserver.current.observe(agreementElement);
                    return function () { var _a; return (_a = resizeObserver.current) === null || _a === void 0 ? void 0 : _a.unobserve(agreementElement); };
                }
                return;
            });
        }
    }, [
        guidedFlowStore.currentStepState,
        guidedFlowStore.allStepsCompleted,
        acceptedInCurrentSession,
        isAnySlotFilled,
        acceptFlowGlobalStore,
        isCurrentSlotFilled,
        isMobileDevice,
        state,
        isMobile,
        onCloseNavDrawer,
    ]);
    if (!isMobileDevice)
        return null;
    if (!guidedFlowStore.hasSteps)
        return null;
    if (!usingFeature(FeatureFlag_1.default.SignatureInitialsWidgets))
        return null;
    if (state === "accepted" || state === "complete")
        return null;
    var handleClick = function () {
        var nextStep = guidedFlowStore.incrementStep();
        var nextElement = nextStep ? document.querySelector((0, Utils_2.getElementSelector)(nextStep.type, nextStep.id)) : null;
        if (nextElement && nextStep) {
            (0, scroll_into_view_if_needed_1.default)(nextElement, (0, Utils_1.getScrollOptionsByStepType)(nextStep.type));
        }
        onCloseNavDrawer === null || onCloseNavDrawer === void 0 ? void 0 : onCloseNavDrawer();
    };
    return (react_1.default.createElement(kaleidoscope_1.Layer, { offset: 2 }, function (_a) {
        var zIndex = _a.zIndex;
        return (react_1.default.createElement(kaleidoscope_1.Stack, { style: { zIndex: zIndex }, padding: "m", className: styles.container, direction: "horizontal", justify: "spaceBetween", align: "center" },
            react_1.default.createElement(kaleidoscope_1.Text, { strong: true }, "Review and Accept"),
            react_1.default.createElement(kaleidoscope_1.Button, { onClick: handleClick, type: kaleidoscope_1.ButtonType.Primary, size: kaleidoscope_1.ButtonSize.Medium }, state === "start" ? "Start" : "Next")));
    }));
});
